<script setup lang="ts">
// Formkit schema: https://formkit.com/api-reference/formkit-inputs#formkitschemaextendablesection
import type { UmbracoFormField } from 'types/blocks';

const { getDefaultFormField } = useForm();

defineProps<{
  field: UmbracoFormField;
}>();
</script>

<template>
  <FormKit
    :help="field.helpText || ''"
    type="checkbox"
    v-bind="getDefaultFormField(field)"
    :validation-messages="{
      accepted: $t('FormMessages.Error.MustAcceptCheckbox'),
    }"
    :validation="field.required ? 'accepted' : ''"
    :value="field.settings.defaultValue !== ''"
    class="!flex-col"
    decorator-icon="check"
  />
</template>
